export default __webpack_public_path__ + "static/media/sunai-navbar-logo.a0879f33.svg";